import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import {
  labelStyle,
  responsiveFun,
  stroke,
  lineXaxis,
  DownloadButton,
} from './options';
import ReducedData from '../reducedData.json';
import trans from '../translations.json';
import ReTable from './EffectiveReproduction-Table';
import { ButtonGroup } from './buttonGroup/buttonGroup';
import './tests/tests.scss';
import { renderToString } from 'react-dom/server';
import { ToolTipClone } from './toolTipClone/toolTipClone';
import { dateFormater, round } from './utils';

const viewModes = {
  graph: 'graph',
  table: 'table',
};

const colors = ['#1080A6', '#96B8E9'];

const reData = [...ReducedData.effectiveReproduction];

class EffectiveReproduction extends Component {
  state = {
    ready: false,
    dates: [],
    series: [],
    options: {},
    selectedViewMode: viewModes.graph,
    selectedSeries: [],
    chartRef: React.createRef(null),
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  componentDidMount() {
    this.setData();
  }

  prepData = () => {
    let preppedData = reData.map((item) => {
      return [item.date_end, item.Re, item.date_start];
    });

    let threshold = reData.map((item) => {
      return [item.date_end, 1];
    });

    return [preppedData, threshold];
  };

  setData = () => {
    const re = [...this.prepData()[0]];
    let threshold = [...this.prepData()[1]];
    let lang = this.props.lang;
    this.setState({
      series: [
        {
          name:
            trans.overview.reproduction.graphTitle[this.props.lang],
          data: re,
          type: 'line',
        },
        // {
        //   name:
        //     trans.overview.reproduction.reThreshold[this.props.lang],
        //   data: threshold,
        //   type: 'line',
        // },
      ],
      options: {
        colors: colors,
        legend: {
          show: false,
        },
        // tooltip: tooltip,
        tooltip: {
          followCursor: true,
          style: { ...labelStyle },
          custom: function ({ series, dataPointIndex, w, value }) {
            let toolTipData = [
              {
                label: trans.overview.reproduction.graphTitle[lang],
                value: series[0][dataPointIndex].toLocaleString(),
                colour: colors[0],
              },
            ];

            const tooltipTitle = () => {
              return (
                dateFormater(
                  w.globals.initialSeries[0].data[dataPointIndex][2],
                ) +
                ' - ' +
                dateFormater(
                  w.globals.initialSeries[0].data[dataPointIndex][0],
                )
              );
            };

            return renderToString(
              ToolTipClone(tooltipTitle(), toolTipData),
            );
          },
        },

        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          id: 'testsDaily',
          type: 'line',
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          zoom: { enabled: true },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text:
              trans.overview.reproduction.graphTitle[this.props.lang],
          },
          labels: {
            style: { ...labelStyle },
            formatter: (value) =>
              this.props.lang === 'fr'
                ? round(value, 1).toLocaleString()
                : round(value, 1)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          },
        },
        stroke: stroke,
        xaxis: {
          ...lineXaxis(true),
        },
        responsive: responsiveFun().map((item) => {
          item.options.xaxis = { ...lineXaxis(true) };
          item.options.yaxis.title.text =
            trans.overview.reproduction.graphTitle[this.props.lang];
          item.options.yaxis.labels.formatter = (value) =>
            this.props.lang === 'fr'
              ? round(value, 1).toLocaleString()
              : round(value, 1)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return item;
        }),
        fill: {
          opacity: 1,
        },
      },
      ready: true,
    });
  };

  render() {
    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <>
              <div style={{ paddingLeft: '0.5rem' }}>
                <ReactApexChart
                  ref={this.state.chartRef}
                  options={this.state.options}
                  series={this.state.series}
                  type="line"
                  height="400px"
                  aria-hidden="true"
                />
              </div>
            </>
          );
        case viewModes.table:
          return <ReTable lang={this.props.lang} />;
        default:
          break;
      }
    };

    return (
      <div id="">
        {this.state.ready && (
          <>
            <ButtonGroup
              selected={this.state.selectedViewMode}
              viewModes={viewModes}
              lang={this.props.lang}
              handleOnClick={this.onViewModeChange}
            />
            <GetRightView />
          </>
        )}
      </div>
    );
  }
}
export default EffectiveReproduction;
